<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      dark
      src="@/assets/img/bgDrawer.jpg"
    >
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title">Mail Server</v-list-item-title>
            <v-list-item-subtitle>by TitanAds Agency</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider />

      <v-list dense>
        <v-list-item
          v-for="([icon, text, link], i) in items"
          :key="i"
          link
          :href="link"
        >
          <v-list-item-icon class="justify-center">
            <v-icon>{{ icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="subtitile-1">{{
              text
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      :color="color"
      :flat="flat"
      dark
      class="px-lg-15 px-10"
      :class="{ expand: flat }"
    >
      <v-toolbar-title>
        <div class="text-sm-h4 text-xs-h5 font-weight-bold"><a style="text-decoration: none; color: white" href="/">TitanAds.Agency</a></div>
      </v-toolbar-title>
      <v-spacer />
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        class="mr-4"
        v-if="isXs"
      />
      <div v-else>
        <v-btn text href="https://www.titanads.agency/" target="_blank">
          <span class="mr-2">Home</span>
        </v-btn>
        <v-btn rounded color="warning" href="/2fa" target="_blank">
          <span class="mr-2">Get 2FA</span>
        </v-btn>
        <v-btn rounded outlined text href="https://t.me/titanads_agency" target="_blank">
          <span class="mr-2">Contact</span>
        </v-btn>
      </div>
    </v-app-bar>
  </div>
</template>

<style scoped>
.v-toolbar {
  transition: 0.6s;
}

.expand {
  height: 80px !important;
  padding-top: 10px;
}
</style>

<script>
export default {
  data: () => ({
    drawer: null,
    isXs: false,
    items: [
      ["mdi-home-outline", "Home", "https://www.titanads.agency/"],
      ["mdi-message-text-outline", "Get 2FA", "/2fa"],
      ["mdi-email-outline", "Liên hệ", "https://t.me/titanads_agency"],
    ],
  }),
  props: {
    color: String,
    flat: Boolean,
  },
  methods: {
    onResize() {
      this.isXs = window.innerWidth < 850;
    },
  },

  watch: {
    isXs(value) {
      if (!value) {
        if (this.drawer) {
          this.drawer = false;
        }
      }
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
};
</script>
